module.exports = __webpack_public_path__ + "img/sprite.9065c594.svg";